import type { SettingsTranslations } from '../interfaces/settings';

export const settingsTranslations: SettingsTranslations = {
  title_page: 'Ajustes',
  subtitle_page: 'Preferencias del workspace y de tu cuenta',
  nav_preferences: 'Preferencias',
  nav_integrations: 'Integraciones',
  nav_organization: 'Organización',
  nav_roles: 'Roles y políticas',
  nav_billing: 'Plan y facturación',
  settings_eyebrow: 'Configuración',
  settings_group_account: 'Cuenta',
  settings_group_integrations: 'Integraciones',
  settings_group_organization: 'Organización',
  language_label: 'Idioma',
  general_settings_title: 'General',
  domain_settings_title: 'Dominio',
  integrations_settings_title: 'Integraciones',
  theme_label: 'Tema',
  theme_description: 'Alterna entre apariencia clara y oscura.',
  theme_light: 'Claro',
  theme_dark: 'Oscuro',
  language_description: 'Elige el idioma que se usa en todo el dashboard.',

  appearance_section_title: 'Apariencia',
  appearance_theme_card_title: 'Tema',
  appearance_theme_card_sub: 'Elige cómo se ve la interfaz. El modo Sistema sigue la preferencia del sistema operativo.',
  appearance_theme_light_hint: 'Pensado para entornos bien iluminados.',
  appearance_theme_dark_hint: 'Menos brillo, ideal para ambientes oscuros.',
  appearance_theme_system_label: 'Sistema',
  appearance_theme_system_hint: 'Sigue el modo claro u oscuro de tu sistema.',

  language_eyebrow: 'Idioma',
  language_section_title: 'Idioma de la interfaz',
  language_section_description: 'Se aplica al instante a todos los textos de la aplicación.',
  language_interface_label: 'Idioma',
  language_interface_hint: 'Tu selección se guarda en este navegador.',

  // Billing
  billing_title: 'Plan y facturación',
  billing_subtitle: 'Administra tu suscripción, métodos de pago y facturas.',
  billing_current_plan_label: 'Plan actual',
  billing_renews_on: 'Renueva el {{date}}',
  billing_per_month: '/ mes',
  billing_per_year: '/ año',
  billing_view_invoice: 'Ver factura',
  billing_upgrade_plan: 'Actualizar plan',
  billing_no_subscription_title: 'No tienes una suscripción activa',
  billing_no_subscription_subtitle:
    'Elige un plan para empezar a usar {{brand}} y desbloquear todos los canales y agentes.',
  billing_choose_plan: 'Elegir plan',
  billing_loading: 'Cargando...',
  billing_usage_of: 'de {{max}}',
  billing_usage_unlimited: 'Ilimitado',
  billing_usage_disabled: 'No incluido',
  billing_usage_per_month: '/ mes',
  billing_feature_agents_active: 'Agentes activos',
  billing_feature_whatsapp_numbers: 'Números WhatsApp',
  billing_feature_team_members: 'Miembros del equipo',
  billing_feature_ai_messages_monthly: 'Mensajes IA',
  billing_feature_whatsapp_conversations_monthly: 'Conversaciones',
  billing_payment_method_title: 'Método de pago',
  billing_payment_method_coming_soon_title: 'Pronto disponible',
  billing_payment_method_coming_soon_description:
    'Estamos trabajando en la integración con pasarelas de pago. Por ahora la facturación se gestiona manualmente desde nuestro equipo.',
  billing_payment_method_change: 'Cambiar',
  billing_invoices_title: 'Historial de facturas',
  billing_invoices_empty_title: 'Aún no hay facturas',
  billing_invoices_empty_description:
    'Cuando se generen pagos asociados a tu suscripción aparecerán aquí.',
  billing_invoices_status_succeeded: 'Pagada',
  billing_invoices_status_pending: 'Pendiente',
  billing_invoices_status_failed: 'Fallida',
  billing_invoices_status_refunded: 'Reembolsada',
  billing_invoices_status_cancelled: 'Cancelada',
  billing_tax_data_title: 'Datos de facturación',
  billing_tax_data_coming_soon_title: 'Pronto disponible',
  billing_tax_data_coming_soon_description:
    'Pronto podrás guardar tus datos fiscales para que aparezcan en tus facturas.',
  billing_tax_data_legal_name: 'Razón social',
  billing_tax_data_tax_id: 'RFC / Tax ID',
  billing_tax_data_address: 'Dirección',
  billing_change_plan_dialog_title: 'Cambiar de plan',
  billing_change_plan_dialog_description:
    'Elige tu nuevo plan. El cambio se aplica de inmediato y reinicia el periodo de facturación.',
  billing_change_plan_dialog_confirm: 'Confirmar cambio',
  billing_change_plan_dialog_cancel: 'Cancelar',
  billing_change_plan_billing_monthly: 'Mensual',
  billing_change_plan_billing_annual: 'Anual',
  billing_change_plan_current_badge: 'Plan actual',
  billing_change_plan_recommended_badge: 'Recomendado',
  billing_change_plan_popular_badge: 'Más popular',
  billing_change_plan_no_plans:
    'No hay planes disponibles. Contáctanos para ayudarte a elegir uno.',
  billing_change_plan_success_toast: 'Plan actualizado correctamente.',
  billing_change_plan_error_toast: 'No pudimos actualizar el plan.',
  billing_change_plan_cta_current: 'Plan actual',
  billing_change_plan_cta_choose: 'Cambiar a {{name}}',
  billing_change_plan_cta_contact: 'Hablar con ventas',
  billing_change_plan_features_title: 'Incluye',
  billing_change_plan_billed_monthly_caption: 'facturado mensual',
  billing_change_plan_billed_annual_caption: '{{total}} cobrados anualmente',
  billing_change_plan_custom_price: 'A medida',
  billing_change_plan_custom_price_caption: 'según volumen',
  billing_change_plan_unlimited_suffix: 'ilimitadas',
  billing_change_plan_per_month_suffix: '/ mes',
  billing_change_plan_back: 'Volver al resumen',
  billing_change_plan_cta_continue: 'Continuar con {{name}}',
  billing_change_plan_need_more: '¿Necesitas más?',
  billing_change_plan_need_more_hint: 'Para volumen alto, SSO o compliance,',
  billing_change_plan_annual_savings: '−2 meses',
  billing_change_plan_free_caption: 'sin cargo',
  billing_trial_cta_start: 'Empezar prueba gratuita de {{days}} días',
  billing_trial_cta_disabled_tooltip:
    'Disponible próximamente · contacta a ventas para activar',
  billing_trial_days_free_badge: '{{days}} días gratis',

  billing_trial_title: 'Estás en prueba gratuita',
  billing_trial_badge: 'Sin plan',
  billing_trial_subtitle:
    'Te quedan {{daysLeft}} de {{daysTotal}} días. Elige un plan para que tus agentes sigan respondiendo después.',
  billing_trial_progress_label: '{{daysLeft}} días restantes',
  billing_no_plan_title: 'Aún no tienes un plan activo',
  billing_no_plan_badge: 'Sin plan',
  billing_no_plan_subtitle:
    'Activa un plan para que tus agentes sigan respondiendo y desbloquear todos los canales.',

  billing_trial_usage_title: 'Tu uso durante la prueba',
  billing_trial_usage_subtitle: 'Te ayuda a estimar qué plan necesitas.',
  billing_trial_usage_conversations: 'Conversaciones',
  billing_trial_usage_conversations_projection:
    '≈ {{projected}} / mes proyectado',
  billing_trial_usage_agents: 'Agentes creados',
  billing_trial_usage_agents_caption: 'incluyendo borradores',
  billing_trial_usage_accounts: 'Cuentas conectadas',
  billing_trial_usage_accounts_caption: 'a través de tus canales',

  billing_faq_title: 'Antes de elegir',
  billing_faq_subtitle: 'Las dudas más comunes.',
  billing_faq_q1: '¿Qué pasa cuando termine mi prueba?',
  billing_faq_a1:
    'Tus agentes pausan respuestas y te avisamos por email 3 días antes. Tus datos y configuración se conservan 90 días por si reactivas.',
  billing_faq_q2: '¿Puedo cambiar de plan más adelante?',
  billing_faq_a2:
    'Sí. Subir es inmediato y se prorratea. Bajar aplica al cierre del ciclo. Sin penalización.',
  billing_faq_q3: '¿Hay descuento si pago anual?',
  billing_faq_a3: 'Sí, equivale a 2 meses gratis sobre la tarifa mensual.',

  billing_checkout_back: 'Cambiar de plan',
  billing_checkout_confirm_title: 'Confirma tu pedido',
  billing_checkout_confirm_subtitle:
    'Tarda menos de un minuto. Te cobraremos al finalizar tu prueba.',
  billing_checkout_plan_label: 'Plan seleccionado',
  billing_checkout_plan_chip_interval_monthly: 'Mensual',
  billing_checkout_plan_chip_interval_annual: 'Anual',
  billing_checkout_card_title: 'Método de pago',
  billing_checkout_card_subtitle: 'Cifrado SSL. No guardamos tu CVC.',
  billing_checkout_card_number: 'Número de tarjeta',
  billing_checkout_card_expiry: 'Vencimiento',
  billing_checkout_card_cvc: 'CVC',
  billing_checkout_card_holder: 'Nombre del titular',
  billing_checkout_tax_title: 'Datos de facturación',
  billing_checkout_tax_legal_name: 'Razón social',
  billing_checkout_tax_id: 'RFC / Tax ID',
  billing_checkout_tax_address: 'Dirección fiscal',
  billing_checkout_summary_label: 'Resumen',
  billing_checkout_summary_billing: 'Facturación',
  billing_checkout_summary_subtotal: 'Plan {{name}}',
  billing_checkout_summary_tax: 'IVA (16%)',
  billing_checkout_summary_total_today: 'Total hoy',
  billing_checkout_pay_button: 'Pagar y activar',
  billing_checkout_pay_processing: 'Procesando…',
  billing_checkout_pay_disclaimer: 'No se cobra hasta finalizar tu prueba.',
  billing_checkout_guarantee_title: 'Cancela cuando quieras',
  billing_checkout_guarantee_description:
    '30 días de garantía. Pago cifrado. Datos en SOC2 + GDPR.',

  billing_done_label: 'Plan activado',
  billing_done_welcome: '¡Bienvenido a {{name}}!',
  billing_done_renews_caption:
    '{{price}} · facturación {{interval}} · renueva el {{date}}',
  billing_done_view_invoice: 'Ver factura',
  billing_done_next_steps_title: 'Próximos pasos',
  billing_done_next_steps_subtitle:
    'Saca el máximo provecho de tu plan en menos de 5 minutos.',
  billing_done_step_connect_title: 'Conecta más cuentas',
  billing_done_step_connect_desc:
    'Añade más WhatsApp, Instagram o tu web para multiplicar el alcance.',
  billing_done_step_handoff_title: 'Activa handoff a humano',
  billing_done_step_handoff_desc:
    'Para conversaciones que requieren un toque humano o pedidos complicados.',
  billing_done_step_webhook_title: 'Configura webhooks',
  billing_done_step_webhook_desc:
    'Recibe eventos en tu backend: leads calificados, ventas cerradas, errores.',
  billing_done_go_to_overview: 'Ir al resumen',
  meta_capi_title: 'Meta Pixel · Conversions API',
  meta_capi_subtitle:
    'Atribuye conversaciones de WhatsApp a tus anuncios de Click-to-WhatsApp y mide conversiones reales en Meta Ads.',
  meta_capi_pixel_id_label: 'Pixel ID',
  meta_capi_access_token_label: 'Access token',
  meta_capi_access_token_set: 'Token guardado',
  meta_capi_access_token_change: 'Cambiar',
  meta_capi_test_event_code_label: 'Código de evento de prueba (opcional)',
  meta_capi_test_event_code_hint:
    'Pegándolo aquí, los eventos aparecerán en la pestaña "Test Events" del Events Manager.',
  meta_capi_enabled_label: 'Habilitado',
  meta_capi_save: 'Guardar configuración',
  meta_capi_test_event: 'Probar evento',
  meta_capi_test_event_sent:
    'Evento de prueba encolado. Mira el log abajo en unos segundos.',
  meta_capi_how_to_get_token: '¿Cómo lo obtengo?',
  meta_capi_how_to_get_token_body:
    'Meta Business Suite → Configuración → Conjuntos de datos → Pixel → Generar token de acceso. Necesitas permisos de administrador del pixel.',
  meta_capi_events_title: 'Últimos eventos enviados',
  meta_capi_events_empty: 'Aún no se han enviado eventos.',
  meta_capi_status_queued: 'En cola',
  meta_capi_status_sent: 'Enviado',
  meta_capi_status_failed: 'Reintentando',
  meta_capi_status_dead: 'Falló',
  meta_capi_toast_saved: 'Configuración guardada.',
  meta_capi_toast_error: 'No se pudo guardar. Intenta de nuevo.',
  meta_capi_required_field: 'Este campo es obligatorio',
  // API keys
  nav_api_keys: 'API keys',
  nav_api_usage: 'Uso de API',
  settings_group_developers: 'Desarrolladores',
  api_keys_eyebrow: 'Desarrolladores',
  api_keys_section_title: 'API keys',
  api_keys_section_description:
    'Crea llaves de API para acceso programático y asígnales uno o más roles que definan sus permisos.',
  api_keys_new: 'Nueva API key',
  api_keys_col_name: 'Nombre',
  api_keys_col_key: 'Llave',
  api_keys_col_roles: 'Roles',
  api_keys_col_status: 'Estado',
  api_keys_col_created: 'Creada',
  api_keys_col_last_used: 'Último uso',
  api_keys_status_active: 'Activa',
  api_keys_status_disabled: 'Revocada',
  api_keys_never_used: 'Nunca',
  api_keys_empty_title: 'Aún no tienes API keys',
  api_keys_empty_description:
    'Crea tu primera llave para acceder a la API con los permisos de un rol.',
  api_keys_load_error: 'No se pudieron cargar las API keys',
  api_keys_action_edit_roles: 'Editar roles',
  api_keys_action_rotate: 'Rotar secreto',
  api_keys_action_revoke: 'Revocar',
  api_keys_action_enable: 'Reactivar',
  api_keys_action_delete: 'Eliminar',
  api_keys_cancel: 'Cancelar',
  api_keys_create_title: 'Nueva API key',
  api_keys_create_description:
    'Nombra la llave y elige los roles que definirán sus permisos.',
  api_keys_create_submit: 'Crear API key',
  api_keys_name_label: 'Nombre',
  api_keys_name_placeholder: 'Ej. Integración CI',
  api_keys_name_required: 'El nombre es obligatorio',
  api_keys_roles_label: 'Roles',
  api_keys_roles_description:
    'La llave hereda los permisos de los roles seleccionados.',
  api_keys_roles_placeholder: 'Selecciona uno o más roles',
  api_keys_roles_required: 'Selecciona al menos un rol',
  api_keys_edit_roles_title: 'Editar roles',
  api_keys_edit_roles_description:
    'Actualiza los roles asociados a esta API key.',
  api_keys_edit_roles_submit: 'Guardar',
  api_keys_col_cidrs: 'Rangos IP',
  api_keys_cidrs_none: 'Sin restricción',
  api_keys_cidrs_count: '{{n}} rango(s)',
  api_keys_action_edit_cidrs: 'Editar rangos IP',
  api_keys_cidrs_label: 'Rangos IP permitidos (CIDR)',
  api_keys_cidrs_description:
    'Opcional. Si agregas rangos, la llave solo funcionará desde IPs dentro de ellos. Vacío = sin restricción. Escribe un CIDR y presiona Enter.',
  api_keys_cidrs_placeholder: 'Ej. 190.85.0.0/16',
  api_keys_cidrs_invalid: 'Ingresa rangos CIDR válidos (ej. 10.0.0.0/8).',
  api_keys_edit_cidrs_title: 'Editar rangos IP',
  api_keys_edit_cidrs_description:
    'Restringe esta API key a una lista de rangos CIDR (IPv4/IPv6). Déjala vacía para permitir cualquier IP.',
  api_keys_edit_cidrs_submit: 'Guardar',
  api_keys_secret_title: 'Guarda tu secreto',
  api_keys_secret_description:
    'Copia estos valores ahora. El secreto se muestra una sola vez y no podrás verlo de nuevo.',
  api_keys_secret_public_label: 'API key (x-api-key)',
  api_keys_secret_secret_label: 'Secreto (x-secret)',
  api_keys_secret_warning:
    'El secreto no se almacena en texto plano. Si lo pierdes, deberás rotarlo.',
  api_keys_secret_copy: 'Copiar',
  api_keys_secret_copied: 'Copiado',
  api_keys_secret_close: 'Listo',
  api_keys_rotate_title: '¿Rotar el secreto?',
  api_keys_rotate_description:
    'Se generará un nuevo secreto y el actual dejará de funcionar de inmediato. Las integraciones que lo usen dejarán de autenticar.',
  api_keys_revoke_title: '¿Revocar esta API key?',
  api_keys_revoke_description:
    'La llave dejará de autenticar de inmediato. Podrás reactivarla más adelante.',
  api_keys_enable_title: '¿Reactivar esta API key?',
  api_keys_enable_description: 'La llave volverá a autenticar peticiones.',
  api_keys_delete_title: '¿Eliminar esta API key?',
  api_keys_delete_description:
    'Esta acción es permanente y no se puede deshacer.',
  api_keys_toast_created: 'API key creada.',
  api_keys_toast_roles_updated: 'Roles actualizados.',
  api_keys_toast_cidrs_updated: 'Rangos IP actualizados.',
  api_keys_toast_rotated: 'Secreto rotado.',
  api_keys_toast_revoked: 'API key revocada.',
  api_keys_toast_enabled: 'API key reactivada.',
  api_keys_toast_deleted: 'API key eliminada.',
  api_keys_toast_error: 'Algo salió mal. Intenta de nuevo.',
  meta_ads_title: 'Meta Ads',
  meta_ads_subtitle: 'Conecta tus cuentas publicitarias de Meta para ver campañas y métricas de pauta en {{brand}}.',
  meta_ads_no_connection_title: 'Sin conexión con Meta',
  meta_ads_no_connection_body: 'Autoriza a {{brand}} con tu cuenta de Meta para leer tus cuentas publicitarias. Solo lectura: no creamos ni modificamos campañas.',
  meta_ads_connect_button: 'Conectar con Meta',
  meta_ads_badge_connected: 'Conectada',
  meta_ads_badge_reauth: 'Requiere reconexión',
  meta_ads_reauth_title: 'La autorización expiró',
  meta_ads_reauth_body: 'Vuelve a conectar tu cuenta de Meta para que {{brand}} siga leyendo tus datos de pauta.',
  meta_ads_expires_label: 'Autorización válida hasta',
  meta_ads_never_expires: 'La autorización no expira',
  meta_ads_disconnect: 'Desconectar',
  meta_ads_accounts_title: 'Cuentas publicitarias',
  meta_ads_accounts_empty: 'Aún no has vinculado ninguna cuenta publicitaria. Carga las disponibles y elige cuáles leer.',
  meta_ads_load_available: 'Cargar cuentas disponibles',
  meta_ads_available_title: 'Disponibles en tu cuenta de Meta',
  meta_ads_available_empty: 'Tu cuenta de Meta no tiene cuentas publicitarias visibles.',
  meta_ads_account_connect: 'Vincular',
  meta_ads_account_connected: 'Vinculada',
  meta_ads_not_covered: 'Sin permiso del token',
  meta_ads_account_status_active: 'Activa',
  meta_ads_account_status_other: 'Revisar en Meta',
  meta_ads_toast_connected: 'Cuenta de Meta conectada.',
  meta_ads_toast_account_connected: 'Cuenta publicitaria vinculada.',
  meta_ads_toast_disconnected: 'Desconectado.',
  meta_ads_toast_cancelled: 'Conexión cancelada.',
  meta_ads_toast_error: 'Algo salió mal. Intenta de nuevo.',
  meta_ads_sdk_error: 'No se pudo cargar el SDK de Facebook. Revisa tu conexión o el bloqueador de anuncios.',
  meta_ads_config_missing: 'Falta configurar el ID de inicio de sesión de Meta Ads para este entorno.',
};
